import { Badge, Box, Button, Drawer, Grid, InputAdornment, TextField, Typography } from "@mui/material"
import { useStyles } from "./styles"
import { DataFilter, ReassignActionPlanProps } from "./type"
import { ModelThree } from "../../../../../reportFolio/pages/dashboard/components/details"
import { NoResponse } from "../../../../../../components/errors/noResponse"
import { useTranslation } from "react-i18next"
import { icons } from "../../../../../../utils/icons"
import { createRef, useCallback, useEffect, useLayoutEffect, useRef, useState } from "react"
import { filterChildrenItem, filterChildrenValue, filterList } from "./methods/filters"
import { DinamicForm } from "../../../../../../components/dinamicForm"
import { Item, onChangeEvent, SnackbarFormat } from "../../../../../../utils/types/generals"
import { actionPlanFetch } from "../../../../../../utils/constants/callService"
import Loader from "../../../../../../components/loader"
import { ArrowBack } from "../../../../../../components/arrowBack"
import SimpleModal from "../../../../../../components/modal/simpleModal"
import { ModalState } from "../../../../../questionnaire/pages/detail/typing/types"
import { ActionPlanReassignBody } from "../../../../../../service/actionPlans/body"
import { useParams } from "react-router-dom"
import { handleAllErrors } from "../../../../../../utils/methods/handleErrors"
import { SnackSimple } from "../../../../../../components"
import { Types } from "../../../../../../utils/enums"
import { LoadingButton } from "@mui/lab"
import { SelectUserRef } from "../../components/selectUser/type"
import FilterButton from "../../components/filterButton"
import SelectUser from "../../components/selectUser"

function Reassign({ userList, filterItems, usersFound, setUsersFound, updateAproverList, close }: ReassignActionPlanProps) {
    const { id } = useParams()
    const { t } = useTranslation()
    const [userSelecteds, setUserSelecteds] = useState<Item[]>(userList)
    const selectUserRef = createRef<SelectUserRef>()
    const styles = useStyles()
    const refTime = useRef<NodeJS.Timeout | null>(null)
    const [drawer, setDrawer] = useState(false)
    // const [usersFound, setUsersFound] = useState<Item[]>([])
    const [model, setModel] = useState(filterList({ t }))
    const [snackbar, setSnackbar] = useState<SnackbarFormat>()
    const [modal, setModal] = useState<ModalState>({ open: false, title: '', description: '' })
    const [search, setSearch] = useState('')
    const [loading, setLoading] = useState({
        search: false,
        save: false,
    })
    const [listFilterd, setListFiltered] = useState(usersFound)
    const [data, setData] = useState<DataFilter>({ area: [], department: [], userType: [] })
    const [countFilter, setCountFilter] = useState(0)
    const handleChange = ({ e }: { e: onChangeEvent }) => {
        const { name, value } = e.target
        if (name == 'area') {
            setData(prev => ({ ...prev, department: filterChildrenValue({ parentValue: value, childrenValue: data.department, key: 'areaId' }) }))
            setModel(prev => ({ ...prev, department: { ...prev?.department, items: filterChildrenItem({ parentValue: value, childrenItem: filterItems.department, key: 'areaId' }) } }))
        }
        setData(prev => ({ ...prev, [name]: value }))
    }

    const openDrawer = () => {
        setDrawer(true)
    }
    const closeDrawer = () => {
        setDrawer(false)
        getCount()
    }

    const closeModal = () => {
        setModal(prev => ({ ...prev, open: false }))
        setLoading(prev => ({ ...prev, save: false }))
    }
    const filter = () => {
        const count = Object.values(data)?.filter(item => !!item.length)?.length
        setCountFilter(count)
        getApprovers({ data })
    }

    const getCount = () => {
        const count = Object.values(data)?.filter(item => !!item.length)?.length
        setCountFilter(count)
    }
    const getApprovers = useCallback(async ({ data }: { data: DataFilter }) => {
        setLoading(prev => ({ ...prev, search: true }))
        const queary = new URLSearchParams()
        const areaString = data.area?.map(area => area.value)?.join(',')
        const departmentString = data.department?.map(department => department.value)?.join(',')
        const userTypeString = data.userType?.map(userType => userType.value)?.join(',')
        if (!!areaString) { queary.append('areas_ids', areaString) }
        if (!!departmentString) { queary.append('departments_ids', departmentString) }
        if (!!userTypeString) { queary.append('user_type_ids', userTypeString) }
        const response = await actionPlanFetch.getApprovers({ queary: queary.toString() })
        if (!response?.errors) {
            closeDrawer()
            const approvers = [...userSelecteds,...response.filter(approver => !userSelecteds.some(selected => selected.id == approver.id))?.map(approver => ({
                label: `${approver.firstName ?? ''} ${approver.lastName ?? ''}`.trim(),
                value: approver.id,
                id: approver.id?.toString(),
                email: approver.email,
                curp: approver.curp,
                role: approver.role
            }))]
            setUsersFound(approvers)
            setListFiltered(appyFilter({usersFound: approvers, search}))
            setLoading(prev => ({ ...prev, search: false }))
            return
        }
    }, [data.area, data.department, data.userType])

    const submit = async ({ body }: { body: ActionPlanReassignBody; users: number[] }) => {
        setLoading(prev => ({ ...prev, save: true }))
        const rsponse = await actionPlanFetch.reassignApprovers(body)
        if (!rsponse?.errors) {
            updateAproverList({ approverUsers: userSelecteds })
            setSnackbar({
                open: true,
                type: Types.SUCCESS,
                message: t('actionPlan.approveAssigned')
            })
            closeModal()
            return
        }
        const code = rsponse?.errors?.[0]?.code
        const errorMessage = handleAllErrors(code, t)
        setSnackbar({
            open: true,
            type: Types.ERROR,
            message: errorMessage
        })
        closeModal()
    }

    const closeSnackbar = () => {
        setSnackbar(undefined)
    }
    const safeUsers = async () => {
        const approverUsers = userSelecteds.map(approver => approver.value)
        setModal(prev => ({
            ...prev,
            open: true,
            title: approverUsers?.length ? t('actionPlan.approverTitle') : t('actionPlan.approverNotSelecets'),
            description: t('actionPlan.approverDescription'),
            confirm: () => {
                if (!approverUsers?.length) {
                    closeModal()
                    return
                }
                if (id) {
                    const body: ActionPlanReassignBody = {
                        id: Number(id),
                        usersApprovers: approverUsers.map(userId => Number(userId)) as number[]
                    }
                    submit({ body, users: approverUsers })
                }
            },
            ...approverUsers?.length && {
                cancel: closeModal,
            },
            close: closeModal,
        }))
        return

    }
    const appyFilter = ({ usersFound, search }: { usersFound: Item[]; search: string }) => {
        return usersFound?.filter(user => (
            user.role?.toLowerCase()?.includes(search?.toLowerCase()) ||
            user.label?.toLowerCase()?.includes(search?.toLowerCase())
        ))
    }
    const filterUsers = ({ search }: { search: string }) => {
        setSearch(search)
        if (refTime.current) {
            clearTimeout(refTime.current)
        }

        refTime.current = setTimeout(() => {
            setListFiltered(appyFilter({search, usersFound}))
        }, 300)
    }
    useLayoutEffect(() => {
        setModel(prev => ({
            ...prev,
            area: { ...prev.area, items: filterItems.area },
            userType: { ...prev.userType, items: filterItems.userType },
        }))
    }, [filterItems.area, filterItems.department, filterItems.userType])

    useEffect(() => {
        setUserSelecteds(userList || [])
    }, [userList])
    return (
        <>
            <Grid sx={styles.container} container spacing={3}>
                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                    <Box className="background flex flex-col gap-2">
                        <ArrowBack
                            label={t('actionPlan.aprovers')}
                            arrowProps={{
                                onClick: close
                            }}
                            boxProps={{
                                sx: { padding: 0 }
                            }}
                        />

                        {
                            (!!userList?.length) && userList?.map((item, index) => (
                                <ModelThree key={index} title={item.label} description={item.email} date={''} />
                            ))
                        }

                        {!userList?.length && <NoResponse label={t('actionPlan.noAprovers')} />}
                    </Box>
                </Grid>

                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                    <Box className="background relative pb-22 flex flex-col gap-2">
                        <Box className="flex item-center gap-2 flex-wrap">
                            <TextField
                                name='search'
                                size="small"
                                value={search}
                                sx={styles.textField}
                                label={t('general.search')}
                                onChange={(e: any,) => {
                                    filterUsers({ search: e.target.value })
                                }}
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">{icons('search')}</InputAdornment>,
                                }}
                            />

                            <Badge badgeContent={countFilter} color="error">
                                <FilterButton sx={styles.filter} onClick={openDrawer} />
                            </Badge>
                        </Box>

                        {!!loading.search && <Loader />}
                        {!loading.search && <SelectUser setUserSelecteds={setUserSelecteds} userSelecteds={userSelecteds} ref={selectUserRef} list={listFilterd} />}

                        <Button onClick={safeUsers} sx={styles.btnFooter} variant="primary_c">{t('general.continue')}</Button>
                    </Box>
                </Grid>
            </Grid>

            <SimpleModal
                open={modal.open}
                description={modal.description}
                close={modal?.close ?? modal?.cancel ?? closeModal}
                title={modal.title}
                buttonText={t('general.confirm')}
                cancelText={t('general.cancel')}
                back={modal?.cancel}
                loadingButton
                isLoading={loading.save}
                next={modal?.confirm ?? closeModal}
            />

            <SnackSimple close={closeSnackbar} open={snackbar?.open} type={snackbar?.type} message={snackbar?.message} />

            <Drawer open={drawer} anchor="right">
                <Box sx={styles.drawer}>
                    <ArrowBack
                        label="Volver al plan de acción"
                        arrowProps={{
                            onClick: closeDrawer
                        }}
                        boxProps={{
                            sx: { padding: 0 }
                        }}
                    />
                    <Typography variant="title_main" color="primary.100">{t('general.filterBy')}</Typography>

                    <DinamicForm values={data} input={Object.values(model)} onChange={(e) => { handleChange({ e }) }} />

                    <Box sx={styles.btnFooter}>
                        <LoadingButton loading={loading.search} onClick={filter} variant="primary_c">{t('general.search')}</LoadingButton>
                    </Box>
                </Box>
            </Drawer>
        </>
    )
}

export default Reassign